import {
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { ArticleState } from './reducer/article.reducer';

export interface State {
  article: ArticleState
}

const articleState = createFeatureSelector<ArticleState>('article');

export const articleSelector = createSelector(
  articleState,
  (state: ArticleState) => state
);
